module.exports = __webpack_public_path__ + "img/ca.c976442e.svg";